import React from 'react';
import PropTypes from 'prop-types';

import {frefFromRef} from '../../../lib/react/higher-order-components';
import {oeInterfaceManager} from '../../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../../react-oe/oe-interface-adapter';
import OEIconCodes from '../../../lib/oe-icon-codes';
import {OENavigationViewComponent} from '../../../lib/components/oe-navigation-controller';
import OEClipboard from '../../../lib/tools/oe-clipboard';
import {OEDefaultConfigFactory} from '../../oe-default-configs';
import OEFlowNavModal from '../flow-nav/oe-flow-nav-modal';
import OEFNElement from '../../elements/oe-flow-nav-elements';
import {OEUserNotificationStyle} from '../oe-user-notification-view';

export class OEFreePremiumViewStd extends React.PureComponent {

    constructor(props) {
        super(props);

        this.options = this.props.options;

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.state = {
            options: this.props.options,
            strings: {
                text:           '',
                email:          '',
                website:        '',
                websiteLabel:   ''
            }
        };

        this.updateLanguage = this.updateLanguage.bind(this);

        this.onOptionsChanged = this.onOptionsChanged.bind(this);

        this.onItemClick = this.onItemClick.bind(this);
        this.onItemSubClick = this.onItemSubClick.bind(this);
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.languageChanged, this.updateLanguage);
    }

    onRelease()    {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.languageChanged, this.updateLanguage);
    }

    updateLanguage()   {
        let si = this.oe.sharedInterface;

        this.setState({strings: {
            text:               si.getLocalizedStringEnc('free_premium_view_text'),
            email:              si.getLocalizedStringEnc('free_premium_view_email'),
            website:            si.getLocalizedStringEnc('free_premium_view_website'),
            websiteLabel:       si.getLocalizedStringRawEnc('free_premium_view_website_label'),
            copyToClipTooltip:  si.getLocalizedStringEnc('tooltip_copy_to_clipboard')
        }});
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            return;
        }

        this.updateLanguage();
    }

    render() {
        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>

                <OEFlowNavModal
                    moduleId={this.props.moduleId}
                    className={'free-premium ' + this.props.className}
                    config={{
                        logo: this.props.config.logo
                    }}
                    isOpen={this.props.isOpen}
                    onOpenStateChanged={this.props.onOpenStateChanged}
                    onOptionsChanged={this.onOptionsChanged}
                    onToggle={this.props.onToggle}
                    ref={this.props.fref}
                >
                    <OENavigationViewComponent title="free_premium_view_title">

                        <OEFNElement.View className="free-premium-view">

                            <OEFNElement.Spacer height="2.5em" /*40px*//>

                            <OEFNElement.Block
                                id="text"
                                content={this.state.strings.text}
                            />

                            <OEFNElement.Spacer height="1.875em" /*30px*//>

                            <OEFNElement.Menu
                                id="website"
                                className="website"
                                iconCode={OEIconCodes.freePremiumView.website}
                                title={this.state.strings.websiteLabel !== undefined ? this.state.strings.websiteLabel : this.state.strings.website}
                                onClick={this.onItemClick}
                            />

                            <OEFNElement.Spacer height="1.1875em" /*19px*//>

                            <OEFNElement.Menu
                                id="email"
                                className="email"
                                iconCode={OEIconCodes.freePremiumView.email}
                                title={this.state.strings.email}
                                subButton={{
                                    icon:               OEIconCodes.copyToClipboard,
                                    tooltipClassName:   'no-modal-backdrop-blur',
                                    tooltipPlacement:   'bottom',
                                    tooltip:            this.state.strings.copyToClipTooltip,
                                    onClick:            this.onItemSubClick
                                }}
                                onClick={this.onItemClick}
                            />

                            <OEFNElement.Spacer height="1.25em" /*20px*//>

                        </OEFNElement.View>

                    </OENavigationViewComponent>

                </OEFlowNavModal>
            </React.Fragment>
        );
    }

    onOptionsChanged(sender, options)  {
        this.options = options;
        this.setState({options: this.options});
    }

    onItemClick(id, sender) {
        if(id == 'email')   {

            /*
            let mail = document.createElement('a');
            mail.href = 'mailto:' + this.state.strings.email;
            mail.click();
            */

            window.location.href = 'mailto:' + this.state.strings.email;

        } else if(id == 'website')   {
            window.open('https://' + this.state.strings.website);
        }
    }

    onItemSubClick(id, sender) {
        if(id == 'email')   {
            let userNotification = this.props.appComponent ? this.props.appComponent.userNotification : undefined;

            OEClipboard.copyText(this.state.strings.email).then(() => {
                if(userNotification)    userNotification.pushMessageId('user_notification_email_copied_to_clipboard', 'Email was copied to clipboard.');
            }, () => {
                if(userNotification)    userNotification.pushMessageId('user_notification_email_copied_to_clipboard_failed', 'Could not copy email to clipboard.', OEUserNotificationStyle.alert);
            });
        }
    }
}

OEFreePremiumViewStd.defaultProps = {
    moduleId:               '',
    className:              '',
    config:                 OEDefaultConfigFactory.freePremiumView()
};

OEFreePremiumViewStd.propTypes = {
    moduleId:               PropTypes.string,
    className:              PropTypes.string,
    config:                 OEDefaultConfigFactory.freePremiumViewDecl,
    isOpen:                 PropTypes.bool,
    options: PropTypes.shape({
        feature:            PropTypes.number
    }),
    onOpenStateChanged:     PropTypes.func,
    onToggle:               PropTypes.func,
    fref:                   PropTypes.func
};

export default frefFromRef(OEFreePremiumViewStd);
